export default {
  station_activity: {
    title: '充电行为记录',
    attr: {
      created_at: '创建时间'
    },
    actions: {
      start_charge: '启动充电',
      stop_charge: '停止充电',
      visit: '访问',
      parking_fee_relief: '停车减免'
    },
    action_results: {
      success: '成功',
      fail: '失败'
    }
  }
}
